import React from 'react';

// project import
import LandingTop from 'sections/landing/LandingTop';
import SolveSection from 'sections/landing/SolveSection';
import ConversionSection from 'sections/landing/ConversionSection';
import FeatureOverviewSection from 'sections/landing/FeatureOverviewSection';
import ServiceListSection from 'sections/landing/ServiceListSection';
import PricingSection from 'sections/landing/PricingSection';
import SupportSection from 'sections/landing/SupportSection';
import IntroductionFlowSection from 'sections/landing/IntroductionFlowSection';
import VoiceSection from 'sections/landing/VoiceSection';
import SystemComparisonSection from 'sections/landing/SystemComparisonSection';
import FaqSection from 'sections/landing/FaqSection';
import ContactSection from 'sections/landing/ContactSection';
import { SEO } from 'hooks/useSeo';

// ==============================|| LANDING PAGE ||============================== //
//
// セクションの並び順は「決裁者(経営者)が上から読んで判断できる順序」で構成している。
//
//   1. LandingTop            ファーストビュー。訴求と資料請求フォーム。料金もここで提示する
//   2. SolveSection          悩みと、それをどう解決するかの流れ
//   3. ConversionSection     資料請求。悩み→解決を読み終えた直後に置く(#document-request)
//   4. FeatureOverviewSection 機能の一覧(加算・減算を先頭に置く)。詳細は /features へ送る
//   5. ServiceListSection    対応サービス。料金を見る前に「うちで使えるか」を確認してもらう
//   6. PricingSection        料金。無料トライアル・初期費用なし・いつでも解約を並べる
//   7. SupportSection        料金の直後に来る「使いこなせるか」への回答(サポート無料・初期設定代行)
//   8. IntroductionFlowSection 申込からご契約までの4ステップ。無料トライアルの中身を開示する
//   9〜10. 導入事例・システム比較
//   11. FaqSection           責任範囲や個人情報など、最後に残る不安の解消
//   12. ContactSection       最終CTA
//
// LandingTop でも月額を提示しているが、そちらは一目で分かる signal として置いており、
// 契約条件まで含めた説明はこの PricingSection が担当する。

const Landing = () => {
  return (
    <React.Fragment>
      <SEO
        title="OHANA AI | 児発・放デイの加算取得と減算対策をAIで"
        description="児童発達支援・放課後等デイサービス向けのAIサービス。個別支援計画書や加算算定に必要な書類をAIが自動作成し、書類の未作成による減算を期限アラートで防止。請求ソフトはそのままに、書類作成業務の負担軽減と属人化の解消を実現します。"
        path="/"
      />

      {/* ファーストビュー 〜 導入判断 */}
      <LandingTop />
      <SolveSection />
      <ConversionSection />
      <FeatureOverviewSection />
      <ServiceListSection />
      <PricingSection />
      <SupportSection />
      <IntroductionFlowSection />

      {/* 導入判断の後押し */}
      <VoiceSection />
      <SystemComparisonSection />
      <FaqSection />
      <ContactSection />
    </React.Fragment>
  );
};

export default Landing;
